"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedQuaternion = void 0;
const ValueObjects_1 = require("../ValueObjects");
class MemoizedQuaternion {
    constructor(initialValue, onChangeCallback) {
        this._val = initialValue;
        this.onChangeCallback = onChangeCallback;
    }
    get val() {
        return this._val;
    }
    set val(v) {
        if (ValueObjects_1.Quaternion.Equal(v, this._val))
            return;
        this._val = v;
        this.onChangeCallback();
    }
    setValQuietly(val) {
        this._val = val;
    }
}
exports.MemoizedQuaternion = MemoizedQuaternion;
